// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const modulesApi = createApi({
  reducerPath: "modulesApi",
  baseQuery: encryptedBaseQueryWithReauth(),
  //baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  tagTypes: ["getModules","getLearnPackage"],
  endpoints: (builder) => ({
    getModules: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getModules"],
    }),
    getModulesbyId: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getModules"],
    }),

    createModule: builder.mutation({
      query: ({ endpoint, data }) => {
        return {
          url: endpoint,
          method: "POST",
          body: data,
          
        };
      },
      invalidatesTags: [],
    }),

    updateModule: builder.mutation({
      query: ({ endpoint, updatedData }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: updatedData,
          
        };
      },
      invalidatesTags: [],
    }),


   
  }),
});

export const {
useGetModulesQuery,useGetModulesbyIdQuery,useCreateModuleMutation,useUpdateModuleMutation
} = modulesApi;
